module.exports = __webpack_public_path__ + "media/images/pc/specials/common/store_hiroshima-5fd5a8d7107fb343707ca4457d18cbd6.jpg";